import type { UserProfile } from '@/api/auth'

/**
 * After-login destination — US-E2-001.
 * Новый юзер (welcomed_at NULL) идёт на /welcome.
 * Welcome-complete'нувший юзер идёт на главную.
 *
 * NB: на UAT/prod `/` обслуживается лендингом (www-v3/index.html), а не SPA.
 * Поэтому проверка welcomed_at не может жить в App.tsx — она должна
 * срабатывать в Login/PinLogin/OAuthCallback ДО редиректа.
 */
export function redirectAfterAuth(user: UserProfile): void {
  const target = user.welcomed_at ? '/' : '/welcome'
  window.location.href = target
}
